export const TB_SET_SUBSCRIBERS_FROM_VIEW = 'tb.set.subscribers.from.view';
export const TB_SET_EMPTY_POINT = 'tb.set.empty.point.start';
// export const TB_SET_EMPTY_POINT_END = 'tb.set.empty.point.end';
export const TB_LOAD_TOUR_DATA_ONE_PART = 'tb.load.tour.data.one.part';
export const TB_DESTROY_SUBSCRIBERS = 'tb.destroy.subscribers';
export const TB_CLEAR_PART_DATA = 'tb.destroy.subscribers';
export const TB_DISTRUCT_ITSELF = 'tb.distruct.itself';
export const TB_CREATE_POINT_ON_MAP = 'tb.create.point.on.map';
export const TB_UP_POINT_ON_MAP = 'tb.up.point.on.map';
export const TB_SHOW_POLY_STR_ON_MAP = 'tb.show.polyline.string.on.map';
export const TB_UP_POLY_ON_MAP_BY_POINT_ID =
  'tb.show.polyline.on.map.by.poin.id';
export const TB_SAVE_PART_DATA_IN_REDUX = 'tb.save.part.data.in.redux';
export const TB_SAVE_PART_DATA_IN_REDUX_USE_TIMESTAMP =
  'tb.save.part.data.in.redux.use.timestamp';
export const TB_REMOVE_POINT_ON_MAP_BY_ID = 'tb.remove.point.on.map.by.id';
export const TB_ADD_EXTRA_TOUR_POINT_BY_SAVED_DATA =
  'tb.add.extra.tour.point.by.saved.data';
export const TB_UPDATE_POINT_ROUTE_PATH = 'tb.update.tour.point.route.path';
export const TB_CLEAR_DELETE_DELAY = 'tb.clear.delete.delay';
export const TB_SAVE_LATEST_POINT_HISTORY = 'tb.save.latest.point.history';
export const TB_MAP_AUTOCORRECT_POINT_COORD = 'TB_MAP_AUTOCORRECT_POINT_COORD';
export const TB_POLY_DRIVE_MAP_CHANGE_POLY = 'TB_POLY_DRIVE_MAP_CHANGE_POLY';
export const TB_POLY_DRIVE_MAP_CHANGE_POINT_POLY =
  'TB_POLY_DRIVE_MAP_CHANGE_POINT_POLY';
export const TB_POLY_DRIVE_MAP_MOVE_POINT_POLY =
  'TB_POLY_DRIVE_MAP_MOVE_POINT_POLY';
export const TB_UPDATE_POINT_SHAPING_POINTS =
  'tb.update.tour.point.shaping.points';
export const TB_SHOW_RT_WAYPOINTS = 'tb.show.rt.waypoints';
// export const TB_SET_SUBSCRIBERS_FROM_HAND = 'tb.set.subscibers.from.hand';

export const TB_HISTORY_PREV_STATE = 'tb.history.prev.state';
export const TB_HISTORY_NEXT_STATE = 'tb.history.next.state';
export const TB_HISTORY_SAVE_STATE = 'tb.history.save.state';
export const TB_HISTORY_CLEAR_STATE = 'tb.history.clear.state';

// ALL TOUR PARTS ON ONE PAGE EVENTS
export const ATP_LOAD_TOUR_DATA_ALL_PARTS = 'atp.load.tour.data.all.parts';
export const ATP_SET_SUBSCRIBERS_FROM_VIEW = 'atp.set.subscribers.from.view';
export const ATP_TB_DESTROY_SUBSCRIBERS = 'atp.destroy.subscribers';
export const ATP_CLEAR_PART_DATA = 'atp.destroy.subscribers';
export const ATP_DISTRUCT_ITSELF = 'atp.distruct.itself';
export const ATP_CREATE_POINT_ON_MAP = 'atp.create.point.on.map';
export const CORRECT_ALL_WRONG_ROUTES_ON_ALL_PAGES =
  'CORRECT_ALL_WRONG_ROUTES_ON_ALL_PAGES';
export const ATP_UPDATE_DISTANCE_DURATION_PART_BY_ID =
  'ATP_UPDATE_DISTANCE_DURATION_PART_BY_ID';
